var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('multiselect',{attrs:{"state":_vm.state,"selected":_vm.value,"options":_vm.options,"disabled":_vm.disabled,"loading":_vm.isLoading,"placeholder":_vm.placeholder},on:{"changeValue":function($event){return _vm.$emit('update:value', $event)},"click":function($event){return _vm.getResearches()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }